module.exports = __webpack_public_path__ + "img/golden-planet.dc1f1b49.svg";